import { useSelector } from "react-redux";

import Th from "@/components/Table/Th";
import { table_head } from "../orders_constants";

const OrdersTableHead = ({ base, setBase }) => {
	const { customer } = useSelector((state) => state.auth.user);

	const setAllOrder = (order, orderType) => {
		setBase({ ...base, order: order, orderType: orderType });
	};

	return (
		<thead>
			<tr>
				{table_head &&
					table_head.map((item, i) => {
						if (i === 7) {
							item.name =
								customer.use_estates_parents && customer.customer_screens.find((cs) => cs.screen_id === 38)
									? customer.customer_screens.find((cs) => cs.screen_id === 38)?.name
									: "Grupos Campos";

							if (!customer.use_estates_parents) {
								return null;
							}
						}
						if (i === 8) {
							item.name = customer.customer_screens.find((cs) => cs.screen_id === 51)
								? customer.customer_screens.find((cs) => cs.screen_id === 51)?.name
								: "Campos";
						}

						return (
							<Th
								key={i}
								item_name={item.name}
								item_size={item.size}
								item_order={item.order}
								order={base.order}
								setOrder={null}
								orderType={base.orderType}
								setOrderType={null}
								item_class={item.class}
								item_check_permission={item.check_permission}
								setAllOrder={setAllOrder}
							/>
						);
					})}
			</tr>
		</thead>
	);
};

export default OrdersTableHead;
